/* eslint-disable no-undef */
/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-06 11:12:09
 */

import React, { useEffect, useRef, useState, useCallback } from 'react'
import { fetchWxQr, fetchWxQrResult } from '../../actions/main'
import sensors from '../../utils/sensors'
import { LoadingOutlined } from '@ant-design/icons'
import { useAppDispatch } from '../../app/hooks'
// import WechatPcLogin from './WechatPcLogin'

// 二维码过期时间 5 分钟
const maxAge = 60 * 1000 * 5

interface ExpiredProps {
  onClick: () => void
}

const Expired = ({ onClick }: ExpiredProps) => {
  return (
    <div className="expired" onClick={onClick}>
      点击刷新
    </div>
  )
}

const Loading = () => {
  return (
    <div className="loading">
      <LoadingOutlined
        style={{
          fontSize: 32
        }}
      />
    </div>
  )
}

interface WeixinQrProps {
  onBack?: () => void
  onSuccess: (data: unknown) => void
  gotoBind?: () => void
}

const WeixinQr = ({ onBack, onSuccess }: WeixinQrProps) => {
  const [qrUrl, setQrUrl] = useState('')
  const [isExpired, setIsExpired] = useState(false)
  const [loading, setLoading] = useState(false)
  // const [showQrCode, setShowQrCode] = useState(false) // 是否显示自研二维码（降级方案）
  const dispatch = useAppDispatch()

  const intervalId = useRef<ReturnType<typeof setInterval> | null>(null)
  const refreshTime = useRef<number | null>(null)
  // 组件是否已卸载：fetchWxQr 是异步的，定时器在 await 之后才创建。
  // 若卸载发生在 await 期间，cleanup 读到的 intervalId.current 仍为 null（清不掉），
  // 待 await 返回又建出一个无人清理的孤儿定时器，导致登录后仍持续轮询 scan/qrcode/status。
  const cancelledRef = useRef(false)

  const fetchQr = useCallback(async () => {
    const { url } = await dispatch(fetchWxQr())

    // 卸载后丢弃本次结果，避免创建孤儿轮询定时器
    if (cancelledRef.current) return

    setQrUrl(url)
    setLoading(false)
    setIsExpired(false)
    if (intervalId.current) clearInterval(intervalId.current)

    refreshTime.current = Date.now()

    intervalId.current = setInterval(() => {
      if (refreshTime.current && Date.now() - refreshTime.current > maxAge) {
        if (intervalId.current) clearInterval(intervalId.current)
        intervalId.current = null

        setIsExpired(true)
      } else {
        dispatch(fetchWxQrResult()).then((res: { status: number }) => {
          if (res.status === 0) {
            if (intervalId.current) clearInterval(intervalId.current)
            intervalId.current = null

            onSuccess(res)
          }
        })
      }
    }, 2000)
  }, [dispatch, onSuccess])

  // 微信快速登录失败时的降级回调
  // const handleWechatPcLoginFallback = useCallback(() => {
  //   setShowQrCode(true)
  // }, [])

  useEffect(() => {
    cancelledRef.current = false
    setLoading(true)
    fetchQr()

    return () => {
      cancelledRef.current = true
      if (intervalId.current) {
        clearInterval(intervalId.current)
        intervalId.current = null
      }
    }
  }, [])

  return (
    <div className="panel weixin-qr">
      <div className="tabs">
        <div
          className={'tab active'}
          onClick={() => {
            // setShowQrCode(true)
            setIsExpired(false)
            setLoading(true)
            fetchQr()
            sensors.track('web_workgroup_click_wechat_login', {
              sourceType: '主动点击'
            })
          }}
        >
          扫码登录
        </div>
        <div
          className={'tab'}
          onClick={() => {
            // 切换到账号/手机登录，通知父组件返回
            if (onBack) onBack()
          }}
        >
          账号登录
        </div>
      </div>

      {/* 微信快速登录组件（使用微信官方 WxLogin） */}
      {/* {!showQrCode && (
        <WechatPcLogin
          onFallback={handleWechatPcLoginFallback}
          onSuccess={onSuccess}
        />
      )}
      {showQrCode && (
        <> */}
      <div className="title">
        <span className="title-blue">微信扫码</span>
        <span className="title-normal">一键登录</span>
      </div>

      <div className="subtitle">扫码关注公众号即可快捷登录</div>

      <div className="qr-container">
        {qrUrl && <img src={qrUrl} className="qr-img" />}
        {isExpired && <Expired onClick={fetchQr} />}
        {loading && <Loading />}
      </div>

      {/* 附加隐私/服务条款 */}
      <p className="policy">
        阅读并接受&nbsp;
        <a target="_blank" href="https://www.xhey.top/x-terms" rel="noreferrer">
          服务条款
        </a>
        &nbsp;和&nbsp;
        <a
          target="_blank"
          href="https://www.xhey.top/x-policy"
          rel="noreferrer"
        >
          隐私政策
        </a>
      </p>
      {/* </>
      )} */}
    </div>
  )
}

export default WeixinQr
